import React, { useMemo } from 'react'
import styled from '@emotion/styled'
import IFrameHtml from '@peracto/peracto-editor-ui/dist/IFrameHtml'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faYoutube } from '@fortawesome/free-brands-svg-icons/faYoutube'
import { isInStorefront } from '../../utils/isInStorefront'

const IFrameContent = styled.div`
    position: relative;
    padding-top: 25px;
    height: 0;
    padding-bottom: ${props => {
        switch (props.aspectRatio) {
            case '4:3':
                return `75%`
            case '1:1':
                return `100%`
            case '2:1':
                return `50%`
            default:
                return `56.25%`
        }
    }};

    iframe {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }
`

const IFrameOverlay = styled.div`
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 100;
`

const getYoutubeUrl = url => {
    if (!url) return

    if (!url.startsWith('<iframe')) {
        let videoCode = url.split('/').pop()

        return `<iframe width="560" height="315" 
            src="https://www.youtube.com/embed/${videoCode}" 
            frameborder="0"
            allow="accelerometer; 
            autoplay; encrypted-media; 
            gyroscope; picture-in-picture" 
            allowfullscreen>
        </iframe>`
    }

    return url
}

let Icon = () => (
    <div className="flex py-10 justify-center items-center w-full">
        <FontAwesomeIcon icon={faYoutube} size="6x" />
    </div>
)

const YouTubeComponent = ({ state: { url, aspectRatio }, isEditMode, isLayoutMode }) => {
    const inStorefront = isInStorefront()

    return (
        <>
            {!isLayoutMode && url && url.length > 0 ? (
                <IFrameContent aspectRatio={aspectRatio} className="content__youtube">
                    <Content url={url} />
                    {isEditMode && <IFrameOverlay />}
                </IFrameContent>
            ) : inStorefront ? (
                <></>
            ) : (
                <Icon />
            )}
        </>
    )
}

const Content = ({ url }) => {
    return useMemo(() => <IFrameHtml content={getYoutubeUrl(url)} />, [url])
}

export default YouTubeComponent
